<template>
	<div class="shop-container">
		<swiper-small :list="bannerArr" />
		<div style="margin: 10px 0;">
		  <Grouplist :list="goodsList" />
		</div>
		<div class="nodata" v-if="!goodsList.length">暂无活动</div>
	</div>
</template>

<script>
	import SwiperSmall from '@/components/common/SwiperSmall'
	import Grouplist from "@/components/layout/grouplist.vue";
	export default {
		components: {
		    SwiperSmall,
				Grouplist
		},
		data() {
			return {
				bannerArr: [],
				goodsList: [],
				page: 1,
				limit: 10,
				totalPage: 0
			}
		},
		methods: {
			handleScroll() {
			  // 变量 scrollHeight 是滚动条的总高度
				let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight				// 变量 windowHeight 是可视区的高度
				let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
				// 变量scrollTop为当前页面的滚动条纵坐标位置
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				// 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
				var scrollBottom = scrollHeight - windowHeight - scrollTop
			
				if(scrollBottom < 800 && this.goodsList.length <= this.totalPage && this.goodsList.length >= this.limit) {
					this.page ++
					this.getList();
				}
			},
			//获取首页banner轮播
			getHomeSlider() {
			  let data = {
			    code: "pc_shop_home_slide"
			  };
			  this.$api.slider(data).then(res => {
			    if (res.status) {
			      this.bannerArr = res.data.list;
			    }
			  });
			},
			//获取商品列表
			getList(){
				let data = {
					page: this.page,
					limit: this.limit,
					type:3
				};				
				this.$api.getGroup(data).then(res => {
					if (res.status) {
						this.totalPage = res.data.count;
						const _list = this.goodsList.concat(res.data.list)
						this.goodsList = _list;
					}
				})
			}
		},
		beforeDestroy() {
		  window.removeEventListener('scroll',this.handleScroll)
		},
		mounted() {
		  window.addEventListener('scroll',this.handleScroll)
		},
		created() {
		  this.getHomeSlider();
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	// 轮播图
	.nav-wrap {
	  width: 100%;
	  position: relative;
	  height: 440px;
	
	  .banner-list {
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    width: 100%;
	    height: 440px;
	    z-index: 10;
	    overflow: hidden;
	    img {
	      display: block;
	      width: 100%;
	      height: 100%;
	      object-fit: cover;
	    }
	  }
	}
	.nodata {
		height: 200px;
		background-color: #fff;
		margin-bottom: 10px;
		text-align: center;
		line-height: 200px;
		user-select: none;
		color: rgb(102, 102, 102);
	}
</style>